import { render, staticRenderFns } from "./model.vue?vue&type=template&id=136e07df&scoped=true&"
import script from "./model.vue?vue&type=script&lang=ts&"
export * from "./model.vue?vue&type=script&lang=ts&"
import style0 from "./model.vue?vue&type=style&index=0&id=136e07df&prod&lang=scss&"
import style1 from "./model.vue?vue&type=style&index=1&id=136e07df&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136e07df",
  null
  
)

export default component.exports